import { observable, toJS } from 'mobx';

export default class AssetLabelModel {
    @observable name = null;
    @observable confidence = null;

    constructor(name, confidence) {
        this.name = name;
        this.confidence = confidence;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        return new AssetLabelModel(object.name, object.confidence);
    }
}
